import React from "react";
import { Button } from "semantic-ui-react";
import Interlocks1_PSM5 from "./Interlocks1_PSM5";
import Interlocks2_PSM5 from "./Interlocks2_PSM5";
import Interlocks3_PSM5 from "./Interlocks3_PSM5";

const Interlocks_PSM5 = () => {
  const [toggleButton, setToggleButton] = React.useState("1");

  const handleClick = (e, { id }) => {
    setToggleButton(id);
  };

  const renderSwitch = (param) => {
    switch (param) {
      case "1":
        return <Interlocks1_PSM5 />;
      case "2":
        return <Interlocks2_PSM5 />;
      case "3":
        return <Interlocks3_PSM5 />;
      default:
        return <Interlocks1_PSM5 />;
    }
  };

  return (
    <div style={styles.div}>
      <Button.Group toggle style={styles.toggle}>
        <Button
          size="medium"
          id="1"
          active={toggleButton === "1"}
          onClick={handleClick}
          content="Interlocks1"
        />
        <Button
          size="medium"
          id="2"
          active={toggleButton === "2"}
          onClick={handleClick}
          content="Interlocks2"
        />
        <Button
          size="medium"
          id="3"
          active={toggleButton === "3"}
          onClick={handleClick}
          content="Interlocks3"
        />
      </Button.Group>
      {renderSwitch(toggleButton)}
    </div>
  );
};

const styles = {
  div: {
    textAlign: "center",
  },
  toggle: {
    marginLeft: "8px",
    marginBottom: "20px",
  },
};

export default Interlocks_PSM5;
